import { css } from 'styled-components';

const cardShadow = css`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const buttonEnableShadow = css`
  box-shadow: inset 0px -2px 0px #558C2F;
`;

const buttonHoverShadow = css`
  box-shadow: 0px 2px 10px rgba(130, 183, 94, 0.3);
`;

const buttonPressedShadow = css`
  box-shadow: inset 0px -2px 0px #3E6524;
`;

const buttonDisabledShadow = css`
  box-shadow: inset 0px -2px 0px #B7B7B7;
`;

const buttonContrastEnabledShadow = css`
  box-shadow: inset 0px -2px 0px #2A334D;
`;

const buttonContrastHoverShadow = css`
  box-shadow: 0px 2px 10px rgba(69, 84, 127, 0.3);
`;

export default {
  cardShadow,
  buttonEnableShadow,
  buttonHoverShadow,
  buttonPressedShadow,
  buttonDisabledShadow,
  buttonContrastEnabledShadow,
  buttonContrastHoverShadow,
};
